import { useTranslation } from "@repo/shared/i18n";

/**
 * The pill that marks something as newly arrived. Takes a label for the
 * variants of that idea the product also ships (a set that has refreshed
 * rather than launched); defaults to "New".
 */
/** Nav entry badges; each is a `common:tags.*` key. */
export type NavTag = "new" | "soon";

export const NewTag = ({ tag }: { tag?: string }) => {
  const { t } = useTranslation("common");
  return (
    <div className="flex h-5 w-fit items-center justify-center whitespace-nowrap rounded-3xl border border-new-tag-border bg-new-tag-background px-2 text-xs font-normal text-white">
      <p className="leading-0">{tag ?? t("tags.new")}</p>
    </div>
  );
};
